import script from "./ercode.vue?vue&type=script&lang=ts&setup=true"
export * from "./ercode.vue?vue&type=script&lang=ts&setup=true"

import "./ercode.vue?vue&type=style&index=0&id=3d55a0a5&scoped=true&lang=css"

import exportComponent from "E:\\vs\\integrate-system\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d55a0a5"]])

export default __exports__